import {CountryData} from "interfaces";
import {action, computed, makeAutoObservable, observable, runInAction} from "mobx";
import {countriesService} from "services";
import {Envs, EnvSetup} from "enums/Envs";
import {CustomAction, supportService} from "services/supportService";
import {SupportActionsMap} from "contexts";
import {SupportActions} from "enums/SupportActions";

class SettingsStore {
    @observable
    countries: CountryData[] = []

    @observable
    selectedCountry: CountryData | undefined

    @observable
    customActions: CustomAction[] = []

    constructor() {
        makeAutoObservable(this)
    }

    @computed
    get countriesSelect() {
        return this.countries?.map(c => ({value: c.countryCode, label: `${c.flag} ${c.name}`}))
    }

    @action
    selectCountry = (country?: string) => {
        this.selectedCountry = country ? this.countries.find(c => c.countryCode === country) : undefined;
    }

    @action
    reset = async (env: EnvSetup, supportedActions: SupportActionsMap) => {
        this.loadCountries(env)
        if (supportedActions[SupportActions.DevTest]) {
            this.loadCustomActions(env)
        }
    }

    private loadCountries = async (env: EnvSetup) => {
        const allItems = await countriesService.getAll(env);
        runInAction(() => {
            this.countries = allItems;
        });
    }

    private loadCustomActions = async (env: EnvSetup) => {
        const areActionsSupported = env && env.env === Envs.Test;
        if (!areActionsSupported) {
            runInAction(() => {
                this.customActions = [];
            });
            return;
        }


        const allItems = await supportService.getSupportActions(env);
        runInAction(() => {
            this.customActions = allItems;
        });
    }
}

export const settingsStore = new SettingsStore()